module.exports = __webpack_public_path__ + "img/img9106.cbbc923a.jpg";